
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [bookingOpen, setBookingOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd />
      <Navigation scrolled={scrolled} onBooking={() => setBookingOpen(true)} />
      <Hero onBooking={() => setBookingOpen(true)} />
      <Portfolio />
      <About />
      <Services />
      <Testimonials />
      <Contact />
      <Gallery />
      <Reviews />
      <Footer />
      <BookingModal isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
    </div>
  );
}
